import { Button, Link, TextField, InputAdornment, Card, Typography} from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import Loading from '../../components/Loading';
import { Stack } from '@mui/system';
import { useCreateDiscountMutation, useDeleteDiscountMutation, useGetDiscountQuery, useUpdateDiscountMutation } from '../../features/model/discountSlice';
import { useValidateDiscountQuery } from '../../features/finder/finderSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const AddDiscountCard = ({salesrep}) => {
    const [addObject, {isLoadingUpdate: isUpdating}] = useCreateDiscountMutation();

    let [newCode, setNewCode] = useState("");
    let [newPercentage, setNewPercentage] = useState("");
    let [percentageField, setPercentageField] = useState({"error": false, "helper": ""});

    if (isUpdating) {
        return <Loading />
    }

    function onAddNew() {
        addObject({salesrep: salesrep.id, code: newCode, metadata: JSON.stringify({"percentage": newPercentage})})
        setNewCode("")
        setNewPercentage("")
    }

    return <Stack direction="column" sx={{margin: 2}} spacing={2}>
        <Typography variant='h2'>Add New Customer Code</Typography>
        <Stack sx={{margin: 2}} spacing={2} direction={"row"}>
            <TextField placeholder='Enter new customer code' label="Customer Code" value={newCode}
                onChange={(event) => {
                    setNewCode(event.target.value)
                }}
            />
            <TextField
                placeholder='Type and press enter...'
                label="Discount Percentage"
                // value={newPercentage}
                error={percentageField.error}
                helperText={percentageField.helper}
                onChange={(event) => {
                    if (event.target.value > 100 || event.target.value < 5) {
                        setPercentageField({...percentageField, error: true, helper: "Value must be between 5% and 100%"})
                    } else {
                        setPercentageField({...percentageField, error: false, helper: ""})
                        setNewPercentage(event.target.value)
                    }
                }}
            />
            <Button disabled={percentageField.error} variant={"outlined"} onClick={() => {
                onAddNew()
            }}>Add Customer Code</Button>
        </Stack>
    </Stack>


}

const DiscountValidationFlag = ({discount, percentage}) => {
    const {data, error, isLoading} = useValidateDiscountQuery(discount.id);
    if(error) {
        return <div>Error</div>;
    }
    if(isLoading) {
        return <Loading />;
    }
    if(data.status === "valid") {
        if(-parseFloat(data.percentage) === parseFloat(percentage)) {
            return <CheckCircleIcon color={"success"} display={"flex"} />;
        }
    }
    return <ErrorIcon color={"error"} display={"flex"} />;
}

const DiscountCard = ({discount, admin=true}) => {
    const {data: object, error, isLoading, refetch} = useGetDiscountQuery(discount.id);
    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateDiscountMutation();
    const [deleteObject] = useDeleteDiscountMutation();
    let [percentage, setPercentage] = useState(JSON.parse(discount.metadata).percentage);
    let [percentageField, setPercentageField] = useState({"error": false, "helper": ""});
    function onPercentageChange(object, newValue) {
        if (newValue > 30 || newValue < 1) {
            setPercentageField({...percentageField, error: true, helper: "Value must be between 1% and 30%"});
        } else {
            setPercentageField({...percentageField, error: false, helper: ""});
            setPercentage(newValue);
            let metadata = JSON.parse(object.metadata);
            metadata.percentage = newValue;
            updateObject({discount_id: object.id, data: {metadata: JSON.stringify(metadata)}});
            refetch();
        }
    }
    if(error) {
        return <></>;
    }

    if ( isUpdating || isLoading) {
      return <Loading />;
    }
    if (!object) {
        return <Loading />;
    }

    return <Stack sx={{margin: 2}} spacing={2} direction={"row"} alignItems={"center"}>
            <TextField InputProps={{readOnly: true,}} id="discount_code" label="Code" defaultValue={object.code} sx={{width: 400}} readOnly={!admin} />
            <TextField error={percentageField.error} id="discount_percentage" label="Discount Percentage" defaultValue={percentage} helperText={percentageField.helper} InputProps={{endAdornment: <InputAdornment position="end">%</InputAdornment>}} onKeyDown={(event) =>{
                if(event.key === 'Enter') {
                    onPercentageChange(object, event.target.value)
                }
            }}
            /><DiscountValidationFlag discount={object} percentage={percentage} />
            <Button variant={"outlined"} onClick={() => {
                navigator.clipboard.writeText(`https://leftcoastcabinets.com/discount/${object.code}`)
            }}>Copy To Clipboard</Button>
            {
                admin ?
                    <Button color="error" variant={"outlined"} onClick={() => {
                        deleteObject(object.id)
                    }
                    }>Delete</Button>
                    :
                    <></>
            }
        </Stack>;
}

export { DiscountCard, AddDiscountCard };
